import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaSave } from "react-icons/fa";
import useFetch from "../../hooks/useFetch";
import { getUserById, updateUser } from "../../services/userService";
import { setUserData } from "../../Utils/localStorageUtils";

const EditProfile = () => {
    const navigate = useNavigate();

    const { id } = useParams();
    const { data: user, loading, error } = useFetch(
        () => getUserById(id),
        [id]
    );

    console.log("user", user, error);

    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        role: "",
        rera_id: "",
        student_id: "",
        profileImage: null,
    });


    const [submitting, setSubmitting] = useState(false);
    const [formError, setFormError] = useState(null); // To display errors if any

    useEffect(() => {
        if (user) {
            setFormData({
                name: user?.data?.name || "",
                mobile: user?.data?.mobile || "",
                role: user?.data?.role || "",
                rera_id: user?.data?.rera_id || "",
                student_id: user?.data?.student_id || "",
                profileImage: null,
            });
        }
    }, [user]);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle image upload
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setFormData({ ...formData, profileImage: file });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true); // Set loading state
        setFormError(null); // Reset error state

        try {
            const updateData = { ...formData };

            // Remove profileImage from API call (if not uploading image to server)
            if (!formData.profileImage) delete updateData.profileImage;

            // Make the API call
            const response = await updateUser(id, updateData);

            if (response.success) {
                setUserData(response?.data)

                // Navigate to profile or display success
                navigate("/profile");
            } else {
                // Display error message from API
                setFormError(response.message || "Failed to update user.");
            }
        } catch (error) {
            // Handle errors
            setFormError(error.response?.data?.message || "An error occurred.");
        } finally {
            setSubmitting(false); // Reset loading state
        }
    };


    if (loading) return <div className="text-center py-[200px]">Loading...</div>;
    if (error)
        return (
            <div className="text-center  text-red-500 py-[200px]">
                {error.message || "An error occurred."}
            </div>
        );

    return (
        <div className="flex justify-center py-[200px] px-4">

            <form
                className="border border-gray-300 rounded-lg shadow-lg p-8 w-full max-w-lg bg-white"
                onSubmit={handleSubmit}
            >
                <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                    Edit Profile
                </h2>

                {/* Profile Image */}
                <div className="flex flex-col items-center mb-6">
                    <img
                        src={
                            formData.profileImage
                                ? URL.createObjectURL(formData.profileImage)
                                : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                        }
                        alt="Profile"
                        className="h-24 w-24 rounded-full object-cover mb-4 border"
                    />
                    <label className="block">
                        <span className="text-sm font-medium text-gray-600">
                            Upload Profile Image
                        </span>
                        <input
                            type="file"
                            accept="image/*"
                            className="mt-2 block w-full text-sm text-gray-500
              file:mr-4 file:py-2 file:px-4
              file:rounded-md file:border-0
              file:text-sm file:font-semibold
              file:bg-blue-50 file:text-blue-700
              hover:file:bg-blue-100"
                            onChange={handleImageChange}
                        />
                    </label>
                </div>

                {/* Name */}
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-600">
                        Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter your name"
                    />
                </div>

                {/* Mobile */}
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-600">
                        Mobile
                    </label>
                    <input
                        type="text"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter your mobile number"
                    />
                </div>

                {/* Role */}
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-600">Role</label>
                    <input
                        type="text"
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter your role"
                    />
                </div>

                {/* RERA ID */}
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-600">
                        RERA ID
                    </label>
                    <input
                        type="text"
                        name="rera_id"
                        value={formData.rera_id}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter your RERA ID"
                    />
                </div>

                {/* Student ID */}
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-600">
                        Student ID
                    </label>
                    <input
                        type="text"
                        name="student_id"
                        value={formData.student_id}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter your student ID"
                    />
                </div>

                {/* Submit Button */}
                <button
                    type="submit"
                    className={`flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition w-full justify-center ${submitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={submitting}
                >
                    {submitting ? (
                        <div className="animate-spin h-5 w-5 border-t-2 border-white rounded-full"></div>
                    ) : (
                        <FaSave />
                    )}
                    {submitting ? "Saving..." : "Save Changes"}
                </button>
                {/* Error Message */}
                {formError && (
                    <div className="mt-4 text-red-500 text-center">{formError}</div>
                )}
            </form>
        </div>
    );
};

export default EditProfile;
